<template>
  <div class="navbar-container d-flex content align-items-center">
    <ul class="nav navbar-nav d-xl-none-icon">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <div class="ml-75 mr-50">
      <h4 class="mb-0 name-user-width text-overflow-ellipsis">
        {{ userInfo.firstName }} {{ userInfo.lastName }}
      </h4>
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <div @click="refreshPage" class="pointer mr-75 ml-75">
        <feather-icon icon="RotateCwIcon" size="21" />
      </div>
      <dark-Toggler />
      <div @click="$bvModal.show('logout-modal')" class="pointer mr-75 ml-75">
        <feather-icon icon="LogOutIcon" size="21" />
      </div>
    </b-navbar-nav>

    <!-------------------------------------- modal logout -------------------------------------->
    <b-modal id="logout-modal" title="خروج از حساب کاربری" centered :hide-footer="true"
      title-class="font-weight-bolder">
      <div class="p-1">
        <h5 class="text-center text-danger mb-3 mt-1">
          آیا می‌خواهید از حساب کاربری خود خارج شوید؟
        </h5>
        <div class="d-flex align-items-center">
          <b-button @click="$bvModal.hide('logout-modal')" class="w-50 mr-1" variant="secondary">
            انصراف
          </b-button>
          <b-button :disabled="logoutLoading" @click="logout" class="w-50" variant="danger">
            خروج
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BButton, BSpinner } from 'bootstrap-vue';
import DarkToggler from './components/DarkToggler.vue';

export default {
  components: {
    BLink,
    BNavbarNav,
    DarkToggler,
    BButton,
    BSpinner
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      logoutLoading: false,
      userInfo: {
        lastName: null,
        firstName: null
      },
    }
  },
  methods: {
    refreshPage() {
      window.location.reload();
    },
    logout() {
      if (!this.logoutLoading) {
        this.logoutLoading = true
        this.$auth.logout().then(() => {
          this.$router.push('/login');
        });
      }
    },
  },
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (userInfo != null) {
      if (userInfo.firstName) {
        this.userInfo = userInfo
      }
    }
  }
};
</script>

<style lang="scss">
@media (min-width: 1300px) {
  .d-xl-none-icon {
    display: none !important;
  }
}

.name-user-width {
  width: 33vw;
}
</style>